import { Color } from "../maths/Color";
export class ColorUtils {
    constructor(value) {
        this.arrColor = [];
        if (value == null || value == 'none') {
            this.strColor = "#00000000";
            this.numColor = 0;
            this.arrColor = [0, 0, 0, 0];
            return;
        }
        tmpColor.parse(value);
        if (typeof (value) == 'string')
            this.strColor = value;
        else
            this.strColor = tmpColor.getStyleString();
        tmpColor.writeTo(this.arrColor);
        this.numColor = tmpColor.getABGR();
    }
    static _initSaveMap() {
        ColorUtils._SAVE_SIZE = 0;
        ColorUtils._SAVE = {};
    }
    static create(value) {
        let key = value + "";
        let color = ColorUtils._SAVE[key];
        if (color != null)
            return color;
        if (ColorUtils._SAVE_SIZE > 500)
            ColorUtils._initSaveMap();
        ColorUtils._SAVE_SIZE++;
        return ColorUtils._SAVE[key] = new ColorUtils(value);
    }
}
ColorUtils._SAVE = {};
ColorUtils._SAVE_SIZE = 0;
const tmpColor = new Color();
